import OverviewMap from './OverviewMap';

export default OverviewMap;
